import React from "react";
import styled from "@emotion/styled";
import FormField from "./FormField";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const BillingDetailsFields = () => {
  return (
    <Grid>
      <FormField full name="name" label="Full name" type="text" placeholder="Jane Doe" required />
      <FormField full name="email" label="Email" type="email" placeholder="jane.doe@example.com" required />
      <FormField full name="address" label="Address" type="text" placeholder="185 Berry St. Suite 550" required />
      <FormField name="city" label="City" type="text" placeholder="San Francisco" required />
      <FormField name="state" label="State" type="text" placeholder="California" required />
      <FormField name="zip" label="ZIP" type="text" placeholder="94103" required />
      <FormField
        name="tel"
        label="Phone"
        type="tel"
        placeholder="(333) 444-5555"
      />
    </Grid>
  );
};

export default BillingDetailsFields;
